import { NgModule } from '@angular/core';

import { OrdersModule } from './orders/orders.module';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { TrackingLayoutComponent } from './tracking-layout/tracking-layout.component';

import { ManagementComponent } from './management/management.component';
import { SearchTemplatesComponent } from './management/templates/search-templates/search-templates.component';
import { CoverageComponent } from './management/coverage/coverage.component';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { CoverageLoadComponent } from './management/coverage/coverage-load/coverage-load.component';
import { CoveragePrioritiesComponent } from './management/coverage/coverage-priorities/coverage-priorities.component';
import { CoverageDownloadComponent } from './management/coverage/coverage-download/coverage-download.component';
import { FileUploadModule } from 'ng2-file-upload';
import { MaterialModule } from '../modules/material.module';
import { NewTemplateComponent } from './management/templates/new-template/new-template.component';
import { DialogChangeTemplateStatusComponent } from './management/templates/search-templates/dialog-change-template-status/dialog-change-template-status.component';
import { DialogDeleteTemplateComponent } from './management/templates/search-templates/dialog-delete-template/dialog-delete-template.component';
import { DialogEditTemplateComponent } from './management/templates/search-templates/dialog-edit-template/dialog-edit-template.component';
import { AuthRedirectionComponent } from './auth-redirection/auth-redirection.component';
import { CoreModule } from '../core/core.module';
import { PipesModule } from '../pipes/pipes.module';
import { SearchProductsComponent } from './products/search-products/search-products.component';
import { ProductTabsComponent } from './products/search-products/product-detail/product-tabs/product-tabs.component';
import { ProductDetailComponent } from './products/search-products/product-detail/product-detail.component';
import { ProductMapComponent } from './products/search-products/product-detail/product-map/product-map.component';
import { TreeComponent } from './products/search-products/product-detail/product-map/tree/tree.component';
import { ProductDepthLevelComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level.component';
import { ProductDepthLevelProductComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-product/product-depth-level-product.component';
import { ProductDepthLevelCfsComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs.component';
import { ProductDepthLevelRfsComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-rfs/product-depth-level-rfs.component';
import { ResourcesModule } from './resources/resources.module';
import { ProductsTreeCardComponent } from './products/search-products/product-detail/product-map/tree/products-tree-card/products-tree-card.component';
import { ProductMapInfoComponent } from './products/search-products/product-detail/product-tabs/product-map-info/product-map-info.component';
import { ProductMapDataComponent } from './products/search-products/product-detail/product-tabs/product-map-data/product-map-data.component';
import { ProductMapLocationsComponent } from './products/search-products/product-detail/product-tabs/product-map-locations/product-map-locations.component';
import { SharedModule } from '../shared/shared.module';
import { ResourcesComponent } from './resources/resources.component';
import { TasksModule } from './tasks/tasks.module';
import { CatalogSearchComponent } from './management/catalog/catalog-search/catalog-search.component';
import { CatalogDetailComponent } from './management/catalog/catalog-search/catalog-detail/catalog-detail.component';
import { CatalogDetailSaveComponent } from './management/catalog/catalog-search/catalog-detail/catalog-detail-save/catalog-detail-save.component';
import { NotificationComponent } from '../core/notification/notification.component';
import { FtthResourcesLoadComponent } from './management/ftth-resources-load/ftth-resources-load.component';
import { ProductMapOrdersComponent } from './products/search-products/product-detail/product-tabs/product-map-orders/product-map-orders.component';
import { ProductDepthLevelProductActionsComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-product/product-depth-level-product-actions/product-depth-level-product-actions.component';
import { TerminateComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-product/product-depth-level-product-actions/terminate/terminate.component';
import { ProductDepthLevelCfsActionsComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/product-depth-level-cfs-actions.component';
import { ValidateCtoComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/validate-cto/validate-cto.component';
import { ChangeCtoComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/change-cto/change-cto.component';
import { NewProductComponent } from './products/new-product/new-product.component';
import { NewProductSuccessComponent } from './products/new-product-success/new-product-success.component';
import { CatalogComponent } from './management/catalog/catalog.component';
import { CatalogLoadComponent } from './management/catalog/catalog-load/catalog-load.component';
import { CatalogListComponent } from './catalog/catalog-list/catalog-list.component';
import { CatalogTabsComponent } from './catalog/catalog-list/catalog-tabs/catalog-tabs.component';
import { CatalogTreeComponent } from './catalog/catalog-list/catalog-tree/catalog-tree.component';
import { CatalogTabCharacteristicsComponent } from './catalog/catalog-list/catalog-tabs/catalog-tab-characteristics/catalog-tab-characteristics.component';
import { CatalogTabGeneralComponent } from './catalog/catalog-list/catalog-tabs/catalog-tab-general/catalog-tab-general.component';
import { CatalogTabDependenciesComponent } from './catalog/catalog-list/catalog-tabs/catalog-tab-dependencies/catalog-tab-dependencies.component';
import { CatalogCardNodeComponent } from './catalog/catalog-list/catalog-tree/catalog-card-node/catalog-card-node.component';
import { IuaHistoricalComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/iua-historical/iua-historical.component';
import { CancelComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-product/product-depth-level-product-actions/cancel/cancel.component';
import { ActivateComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-product/product-depth-level-product-actions/activate/activate.component';
import { ChangeServiceComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/change-service/change-service.component';
import { InstallComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-product/product-depth-level-product-actions/install/install.component';
import { SearchServiceTemplatesComponent } from './management/service-templates/search-service-templates/search-service-templates.component';
import { NewServiceTemplateComponent } from './management/service-templates/new-service-template/new-service-template.component';
import { DialogChangeServiceTemplateStatusComponent } from './management/service-templates/search-service-templates/dialog-change-service-template-status/dialog-change-service-template-status.component';
import { DialogDeleteServiceTemplateComponent } from './management/service-templates/search-service-templates/dialog-delete-service-template/dialog-delete-service-template.component';
import { DialogEditServiceTemplateComponent } from './management/service-templates/search-service-templates/dialog-edit-service-template/dialog-edit-service-template.component';
import { RetryComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-product/product-depth-level-product-actions/retry/retry.component';
import { MoveCtoComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/move-cto/move-cto.component';
import { ChangeFsanComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/change-fsan/change-fsan.component';
import { UpdateFsanComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/update-fsan/update-fsan.component';
import { PartyComponent } from './management/party/party.component';
import { NewPartyComponent } from './management/party/new-party/new-party.component';
import { UpdatePartyComponent } from './management/party/update-party/update-party.component';
import { DeletePartyComponent } from './management/party/delete-party/delete-party.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ProductDepthLevelRfsActionsComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-rfs/product-depth-level-rfs-actions/product-depth-level-rfs-actions.component';
import { InstallationStatusComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-rfs/product-depth-level-rfs-actions/installation-status/installation-status.component';
import { CancelInstallationComponent } from './orders/specific-order/order-details/order-tabs/order-details-installation-status/cancel-installation/cancel-installation.component';
import { ChangeCpeComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/change-cpe/change-cpe.component';
import { IpListComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-rfs/product-depth-level-rfs-actions/ip-list/ip-list.component';
import { ChangeOntPasswordComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/change-ont-password/change-ont-password.component';
import { TvPackagesComponent } from './products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-product/product-depth-level-product-actions/tv-packages/tv-packages.component';
import { TaskManagementComponent } from './management/taskmanagement/taskmanagement.component';
import { DeleteQueueComponent } from './management/taskmanagement/delete-queue/delete-queue.component';
import { UpdateQueueComponent } from './management/taskmanagement/update-queue/update-queue.component';
import { AddQueueComponent } from './management/taskmanagement/add-queue/add-queue.component';
import { AssignQueueComponent } from './tasks/specific-task/assign-queue/assign-queue.component';
import { MasterDataComponent } from './management/master-data/master-data.component';
import { UpdateMasterDataComponent } from './management/master-data/update-master-data/update-master-data.component';
import { NewMasterDataComponent } from './management/master-data/new-master-data/new-master-data.component';
import { PortOutComponent } from './management/port-out/port-out.component';
import { PortOutDetailComponent } from './management/port-out/port-out-detail/port-out-detail.component';

@NgModule({
  declarations: [
    MainLayoutComponent,
    TrackingLayoutComponent,
    ManagementComponent,
    SearchTemplatesComponent,
    CoverageComponent,
    CoverageLoadComponent,
    CoveragePrioritiesComponent,
    CoverageDownloadComponent,
    NewTemplateComponent,
    DialogChangeTemplateStatusComponent,
    DialogDeleteTemplateComponent,
    DialogEditTemplateComponent,
    SearchProductsComponent,
    ProductTabsComponent,
    DialogEditTemplateComponent,
    AuthRedirectionComponent,
    ProductDetailComponent,
    ProductMapComponent,
    TreeComponent,
    ProductDepthLevelComponent,
    ProductDepthLevelProductComponent,
    ProductDepthLevelCfsComponent,
    ProductDepthLevelRfsComponent,
    ProductsTreeCardComponent,
    ProductMapInfoComponent,
    ProductMapDataComponent,
    ProductMapLocationsComponent,
    ResourcesComponent,
    CatalogComponent,
    CatalogLoadComponent,
    CatalogSearchComponent,
    CatalogDetailComponent,
    CatalogDetailSaveComponent,
    FtthResourcesLoadComponent,
    ProductMapOrdersComponent,
    ProductDepthLevelProductActionsComponent,
    ProductDepthLevelCfsActionsComponent,
    ChangeCtoComponent,
    ValidateCtoComponent,
    NewProductComponent,
    NewProductSuccessComponent,
    CatalogListComponent,
    CatalogTabsComponent,
    CatalogTreeComponent,
    CatalogTabCharacteristicsComponent,
    CatalogTabGeneralComponent,
    CatalogTabDependenciesComponent,
    CatalogCardNodeComponent,
    IuaHistoricalComponent,
    CancelComponent,
    ActivateComponent,
    ChangeServiceComponent,
    InstallComponent,
    TerminateComponent,
    SearchServiceTemplatesComponent,
    NewServiceTemplateComponent,
    DialogChangeServiceTemplateStatusComponent,
    DialogDeleteServiceTemplateComponent,
    DialogEditServiceTemplateComponent,
    RetryComponent,
    MoveCtoComponent,
    ChangeFsanComponent,
    UpdateFsanComponent,
    PartyComponent,
    NewPartyComponent,
    UpdatePartyComponent,
    DeletePartyComponent,
    ProductDepthLevelRfsActionsComponent,
    InstallationStatusComponent,
    ChangeCpeComponent,
    IpListComponent,
    ChangeOntPasswordComponent,
    TvPackagesComponent,
    TaskManagementComponent,
    DeleteQueueComponent,
    UpdateQueueComponent,
    AddQueueComponent,
    AssignQueueComponent,
    MasterDataComponent,
    UpdateMasterDataComponent,
    NewMasterDataComponent,
    PortOutComponent,
    PortOutDetailComponent
  ],
  imports: [
    OrdersModule,
    TasksModule,
    ResourcesModule,
    MaterialModule,
    HttpClientModule,
    SharedModule,
    CoreModule,
    PipesModule,
    TranslateModule.forChild(),
    FileUploadModule,
    ReactiveFormsModule
  ],
  entryComponents: [
    DialogChangeTemplateStatusComponent,
    DialogDeleteTemplateComponent,
    DialogEditTemplateComponent,
    DialogChangeServiceTemplateStatusComponent,
    DialogDeleteServiceTemplateComponent,
    DialogEditServiceTemplateComponent,
    CatalogDetailSaveComponent,
    NotificationComponent,
    ChangeCtoComponent,
    ChangeCpeComponent,
    MoveCtoComponent,
    ValidateCtoComponent,
    NewProductSuccessComponent,
    IuaHistoricalComponent,
    CancelComponent,
    ActivateComponent,
    ChangeServiceComponent,
    InstallComponent,
    TerminateComponent,
    RetryComponent,
    ChangeFsanComponent,
    UpdateFsanComponent,
    UpdatePartyComponent,
    DeletePartyComponent,
    InstallationStatusComponent,
    CancelInstallationComponent,
    IpListComponent,
    ChangeOntPasswordComponent,
    TvPackagesComponent,
    DeleteQueueComponent,
    UpdateQueueComponent,
    AddQueueComponent,
    AssignQueueComponent,
    MasterDataComponent,
    UpdateMasterDataComponent,
    NewMasterDataComponent
  ],
  exports: [MainLayoutComponent, ManagementComponent, DialogChangeTemplateStatusComponent, TrackingLayoutComponent],
})
export class LayoutModule {
}
